module.exports = __webpack_public_path__ + "img/5.3d0ca69f.jpg";